var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back-button button",attrs:{"type":"button"},on:{"click":_vm.back}},[_c('span',{staticClass:"u-screen-reader-only"},[_vm._v(" Back ")]),_c('IconBack')],1)}
var staticRenderFns = []

export { render, staticRenderFns }